export const ETooltipContent = {
  Second: 'Размещает достоверные и качественные объявления',
  Third: 'Долго работает с Циан и размещает\nдостоверные и качественные объявления',
  Fourth: 'Один из лучших специалистов Циан. Размещает только достоверные объявления' +
    ' и предоставляет качественные услуги.',
  Nothing: 'К сожалению информация отсутствует',
};



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/WorkHonestlyTooltip/constants.ts